// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";


// import { io } from "socket.io-client";

// const socket = io("${BASE_URL}");

// const MyOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const navigate = useNavigate();
//   const token = localStorage.getItem("auth-token");

//  useEffect(() => {
//   if (!token) return;

//   fetch("${BASE_URL}/myorders", {
//     headers: { "auth-token": token },
//   })
//     .then(res => res.json())
//     .then(data => setOrders(data));

//   socket.on("order-status-updated", ({ orderId, status }) => {
//     setOrders(prev =>
//       prev.map(o =>
//         o._id === orderId ? { ...o, status } : o
//       )
//     );
//   });

//   return () => socket.off("order-status-updated");
// }, [token]);


//   return (
//     <div className="my-orders">
//       <h2>My Orders</h2>

//       {orders.length === 0 && <p>No orders found</p>}

//       {orders.map(order => (
//         <div key={order._id} className="order-card">
//           <p><b>Order ID:</b> {order._id}</p>
//           <p><b>Status:</b> {order.status}</p>
//           <p><b>Total:</b> ${order.totalAmount}</p>

//           <button onClick={() => navigate(`/order/${order._id}`)}>
//             View Details
//           </button>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default MyOrders;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import "../Pages/CSS/MyOrder.css";
import BASE_URL from '../Config/api.js';
const socket = io(`${BASE_URL}`);

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("auth-token");

  useEffect(() => {
    if (!token) return;

    fetch(`${BASE_URL}/myorders`, {
      headers: { "auth-token": token },
    })
      .then((res) => res.json())
      .then((data) => setOrders(data || []));

    socket.on("order-status-updated", ({ orderId, status }) => {
      setOrders((prev) =>
        prev.map((o) =>
          o._id === orderId ? { ...o, status } : o
        )
      );
    });

    return () => socket.off("order-status-updated");
  }, [token]);

  return (
    <div className="my-orders-container">
      <h2 className="page-title">My Orders</h2>

      {orders.length === 0 ? (
        <div className="empty-orders">
          <p>📦 No orders yet</p>
          <span>Once you place an order, it will appear here.</span>
        </div>
      ) : (
        <div className="orders-grid">
          {orders.map((order) => (
            <div key={order._id} className="order-card">
              <div className="order-header">
                <span className="order-id">
                  #{order._id.slice(-6)}
                </span>
                <span
                  className={`status-badge ${order.status?.toLowerCase()}`}
                >
                  {order.status}
                </span>
              </div>

              <div className="order-body">
                <p>
                  <strong>Total:</strong> Rs.{order.totalAmount}
                </p>
                <p>
                  <strong>Date:</strong>{" "}
                  {new Date(order.createdAt).toLocaleDateString()}
                </p>
              </div>

              <button
                className="view-btn"
                onClick={() =>
                  navigate(`/order/${order._id}`)
                }
              >
                View Details
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyOrders;
